import { render, staticRenderFns } from "./PolicySignAllActivities.vue?vue&type=template&id=c0276cb8"
import script from "./PolicySignAllActivities.vue?vue&type=script&lang=ts"
export * from "./PolicySignAllActivities.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports